import script from "./BroadcastAndCourse.vue?vue&type=script&lang=ts&setup=true"
export * from "./BroadcastAndCourse.vue?vue&type=script&lang=ts&setup=true"

import "./BroadcastAndCourse.vue?vue&type=style&index=0&id=601eb97f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-601eb97f"]])

export default __exports__